<template>
  <form novalidate class="md-layout" :class="content.class_color" @submit.prevent="validateContact">
    <md-field :class="getValidationClass('name')">
      <label for="first-last-name">Nombres y apellidos</label>
      <md-input name="first-last-name" id="first-last-name" class="input-black" autocomplete="given-name"
                v-model="form.name" :disabled="sending"/>
      <span class="md-error" v-if="!$v.form.name.required">El nombre y apellido es requerido</span>
      <span class="md-error" v-else-if="!$v.form.name.minlength">Nombre y apellido inválido</span>
    </md-field>


    
    <md-field :class="getValidationClass('phone')">
      <label for="last-name">Celular</label>
      <md-input name="last-name" id="last-name" autocomplete="family-name" v-model="form.phone"
                :disabled="sending" v-mask="'### ### ###'"/>
      <span class="md-error" v-if="!$v.form.phone.required">El número telefónico es requerido</span>
      <span class="md-error" v-else-if="!$v.form.phone.minlength && form.phone !== ''">Teléfono inválido</span>
      <span class="md-error" v-else-if="!$v.form.phone.maxLength && form.phone !== ''">Teléfono inválido</span>
      <span class="md-error" v-else-if="!$v.form.phone.numeric && form.phone !== ''">Teléfono inválido</span>
    </md-field>


    <md-field :class="getValidationClass('email')">
      <label for="email">Correo electrónico</label>
      <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email"
                :disabled="sending"/>
      <span class="md-error" v-if="!$v.form.email.required">El Email es requerido</span>
      <span class="md-error" v-else-if="!$v.form.email.email">Email inválido</span>
    </md-field>

    
    <div class="md-field formulario-center-button">
      <div  id="formulario-boton">
        <button v-if="content.boton_img" type="submit" :disabled="sending" class="button-primary-global">
                <span class="button-text-global">
                    {{ content.text_boton }}
                    <!-- <img src="@/assets/images/arrow_left.svg"> -->
                </span>
        </button>
        <button v-else type="submit" :disabled="sending" class="button-primary-global">
          <span class="button-text-global-normal"> {{ content.text_boton }}</span>
        </button>
      </div>
    </div>
    <div class="md-field formulario-center-button" v-if="showDismissibleAlert">
      <div class="mt-1 pb-1">
        <b-alert style="text-align: center" id="alert-send"
                 v-model="showDismissibleAlert"  dismissible>
          <span> <strong>{{ lastUser }}</strong><br> Pronto le será agendada una cita!</span>
        </b-alert>
      </div>
    </div>
    <div class="md-field formulario-center-button" v-if="showDismissibleAlertError">
      <div class="mt-1 pb-1">
        <b-alert style="text-align: center" id="alert-send-ganger" variant="danger"
                 v-model="showDismissibleAlertError"  dismissible>
          <span> Intente mas tarde</span>
        </b-alert>
      </div>
    </div>
    <div class="vld-parent">
      <loading :active.sync="sending"
               :can-cancel="true"
               loader="dots"
               color="#FFC100"
               backgroundColor="black"
               :width=128
               :height=128
               :is-full-page="true">
      </loading>
    </div>
  </form>
</template>
<script>
  import { validationMixin } from 'vuelidate'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  import {
    required,
    email,
    minLength,
    maxLength,
  } from 'vuelidate/lib/validators'

  export default {
    name: 'formulario',
    mixins: [validationMixin],
    components: {Loading},
    props: {content: Object},
    data: () => ({
      form: {
        name: null,
        company: null,
        branch: null,
        phone: null,
        phoneNumeric: null,
        email: null,
      },
      contactSaved: false,
      sending: false,
      lastUser: null,
      showDismissibleAlert: false,
      showDismissibleAlertError: false
    }),
    validations: {
      form: {
        name: {
          required,
          minLength: minLength(3)
        },
        company: {
          required,
          minLength: minLength(3)
        },
         branch: {
          required,
          minLength: minLength(3)
        },
        phone: {
          required,
          minLength: minLength(9), // Solo 9 dígitos sin espacios
          maxLength: maxLength(11) // Permitir espacios en la UI: ### ### ###
        },
        email: {
          required,
          email
        }
      }
    }, methods: {
      getValidationClass (fieldName) {
        const field = this.$v.form[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      clearForm () {
        this.$v.$reset()
        this.form.name = null
        this.form.company = null
        this.form.branch = null
        this.form.phone = null
        this.form.email = null
      },
      saveContact () {
        this.sending = true
        
        // Limpiar el número de teléfono antes de enviar
        const cleanPhone = this.form.phone ? this.form.phone.replace(/\s/g, '') : '';
        const formData = {
          ...this.form,
          phone: cleanPhone,
          phoneNumeric: cleanPhone
        };
        
        this.$store.dispatch('registerContact', formData)
          .then(() => {
            this.showDismissibleAlert = true
            this.lastUser = `${this.form.name} ${this.form.phone}`
            this.contactSaved = true
            this.sending = false
            this.clearForm()
//            alert('Pronto sera atendido por uno de nuestros equipos GOX')
            /*revisar esto es para la barra de carga*/
//            window.setTimeout(() => {
//              this.lastUser = `${this.form.name} ${this.form.phone}`
//              this.contactSaved = true
//              this.sending = false
//              this.clearForm()
//            }, 1500)
          })
          .catch((error) => {
            console.error('Error al enviar contacto:', error);
            console.error('Detalles:', error.response?.data);
            this.sending = false
            this.showDismissibleAlertError= true
          })
        // Instead of this timeout, here you can call your API

      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      validateContact () {
        this.$v.$touch()

        if (!this.$v.$invalid) {
          this.saveContact()
        }
      },
      srcImagen(img) {
        let src = require('@/assets/images/' + img)
        return src
      },
      doAjax() {
        this.isLoading = true;
        // simulate AJAX
        setTimeout(() => {
          this.isLoading = false
        },5000)
      },
      onCancel() {
        // console.log('User cancelled the loader.')
      }
    }
  }
</script>
<style scoped>
</style>